import { render } from "./ViewBlogger.vue?vue&type=template&id=1b44c136&scoped=true"
import script from "./ViewBlogger.vue?vue&type=script&lang=js"
export * from "./ViewBlogger.vue?vue&type=script&lang=js"

import "./ViewBlogger.vue?vue&type=style&index=0&id=1b44c136&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b44c136"]])

export default __exports__